import { Record } from 'immutable';
export default Record({
  enabled: false,
  startHour: 9,
  stopHour: 10
});